import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import { createStore, combineReducers, compose, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import reducers from "./Store/Reducers";
// import { registerServiceWorker } from "./register-sw";

// registerServiceWorker();

const store = createStore(combineReducers(reducers), compose(applyMiddleware(thunk)));

const app = ( 
    <Provider store = { store } >
    <App />
    </Provider>
);



ReactDOM.render(app, document.querySelector('#root'));